export enum InnovationQueries {
  InnovationTable = 'innovationTable',
  SearchInnovationChangeDummy = 'searchInnovationChangeDummy',
}
